import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
            <div className="lg:max-w-sm">
              <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-movie-2-line text-2xl text-primary-400"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50">
                  {t('site.name')}
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                {t('site.slogan')} — {t('home.heroSubtitle')}
              </p>
            </div>

            <div className="flex flex-wrap gap-10 lg:gap-16 flex-1">
              <div>
                <h4 className="font-heading text-sm font-bold text-background-50 mb-4">
                  快捷导航
                </h4>
                <ul className="space-y-2.5">
                  <li>
                    <Link
                      to="/category/dianying"
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                    >
                      {t('nav.movies')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/category/dianshiju"
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                    >
                      {t('nav.tvShows')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/category/zongyi"
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                    >
                      {t('nav.variety')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/category/dongman"
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                    >
                      {t('nav.anime')}
                    </Link>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="font-heading text-sm font-bold text-background-50 mb-4">
                  关于我们
                </h4>
                <ul className="space-y-2.5">
                  <li>
                    <Link
                      to="/about"
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                    >
                      {t('about.brandIntro')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/about"
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                    >
                      {t('about.reputation')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/about"
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                    >
                      {t('about.contact')}
                    </Link>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="font-heading text-sm font-bold text-background-50 mb-4">
                  联系方式
                </h4>
                <ul className="space-y-2.5">
                  <li>
                    <a
                      href={`mailto:${t('about.contactEmail')}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 flex items-center gap-2"
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-mail-line"></i>
                      </div>
                      {t('about.contactEmail')}
                    </a>
                  </li>
                  <li>
                    <span className="text-sm text-background-400 flex items-center gap-2">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-phone-line"></i>
                      </div>
                      {t('about.contactPhone')}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              {t('footer.copyright')}
            </p>
            <div className="flex items-center gap-6">
              <a
                href="#"
                className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200"
              >
                {t('footer.privacy')}
              </a>
              <a
                href="#"
                className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200"
              >
                {t('footer.terms')}
              </a>
            </div>
          </div>
          <p className="text-xs text-background-600 mt-3 text-center sm:text-left">
            {t('footer.disclaimer')}
          </p>
        </div>
      </div>
    </footer>
  );
}